import lang from './lang.json'

export const getLanguages = () => lang.languages;
